import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import GlobalErrorBoundary from "./global-boundary";
import './i18n';

const root = ReactDOM.createRoot(document.getElementById("root"));
// Initialize theme early to avoid flash
(() => {
  try {
    const saved = localStorage.getItem('theme');
    const root = document.documentElement;
    if (saved === 'light' || saved === 'dark') {
      root.setAttribute('data-theme', saved);
    } else {
      root.removeAttribute('data-theme');
    }
  } catch {}
})();

root.render(
  <GlobalErrorBoundary>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </GlobalErrorBoundary>
);
